import React, { useState } from "react";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import Landing from "../Landing/Landing";
import Navbar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";
import SideBar from "../SideBar/SideBar";
import "./Content.css";
import "./Achivement.css";
import achTopIcon from "../../image/newImg/ach.png";
import bullet_icon from "../../image/bullet_icon.svg";
import award_1 from "../../image/a1.png";
import award_2 from "../../image/a2.png";
import award_3 from "../../image/award_3.jpg";
import award_4 from "../../image/award_4.jpg";
import award_5 from "../../image/award_5.jpg";
import award_6 from "../../image/award_6.jpg";
import award_7 from "../../image/award_7.jpg";
import award_8 from "../../image/award_8.jpg";
import award_9 from "../../image/award_9.jpg";
import award_10 from "../../image/award_10.jpg";
import a1 from "../../image/newImg/a1.jpg";
import a2 from "../../image/newImg/a2.jpg";
import a3 from "../../image/newImg/a3.jpg";
import a4 from "../../image/newImg/a4.jpg";
import a5 from "../../image/newImg/a5.jpg";
import a6 from "../../image/newImg/a6.jpg";
import a7 from "../../image/newImg/a7.jpg";
import a8 from "../../image/newImg/a8.jpg";
import a9 from "../../image/newImg/a9.jpg";
import a10 from "../../image/newImg/a10.png";
import a11 from "../../image/newImg/a11.png";
import a12 from "../../image/newImg/a12.jpg";
import { Col, Row } from "react-bootstrap";
function Achievements(props) {
  const { cover, sidebar_data, side_heading, side_sub_heading } = props;
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, steIsShow] = useState(false);
  const handleScroll = (e) => {
    console.log("asd");
    if (e.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }
    if (e.target.scrollTop === 0) {
      setIsScrolled(false);
    }
  };
  const handleClick = () => {
    steIsShow(!isShow);
    console.log(isShow);
  };

  return (
    <div className="content_main" onScroll={handleScroll}>
      <Navbar isScrolled={isScrolled} handleClick={handleClick} />
      <NavbarMenu isShow={isShow} handleClick={handleClick} />
      <Landing video={false} cover={cover} />
      <div className="contentmain_cont">
        <div style={{ width: "min-content" }}>
          <SideBar
            sidebar_data={sidebar_data}
            side_heading={side_heading}
            side_sub_heading={side_sub_heading}
          />
          <Contact />
        </div>
        <div>
          <div className={`f-2 f-500 mb-3`}>
            Achievements & Laurels
          </div>

          <div>
            <div className="d-flex gap-2 mt-1">
              <div>
                <div className="color-grey f-500">
                  Hermann Geminer School proudly highlights its achievements and
                  presents the best of its students, whether they are excelling
                  academically, athletically or in service to the community. We
                  hope to inspire more students to excel, their achievements
                  ultimately make the school become stronger.By highlighting
                  student achievements, we aim to eliminate self-doubt and build
                  confidence in our students that hard work is important and is
                  making an impact. In turn, this confidence can carry over to
                  other facets of their young lives, including making smart
                  choices when faced with several challenges as they grow up.
                </div>



                <div className="achievement_section mt-4">
                  <div className="achievement_content row">
                    <div className="col-lg-6 achiecontent">
                      <h2 className="section_titless">School’s Achievements</h2>
                      <ul style={{ listStyleType: "none" }}>
                        <li>
                          <h4 className="text-white">In literary competitions:</h4>
                          <ul>
                            <li className="achivement">
                              (2015-16)- Sweety got first position in English
                              recitation.
                            </li>
                            <li className="achivement">
                              <span>
                                (2017-18)- Ritika Got second position in English
                                declamation
                              </span>
                              <br />
                            </li>
                            <li className="achivement">
                              Nikhil got first position in poem recitation
                            </li>
                            <li className="achivement">
                              Shambhavi got second position in Hindi declamation
                            </li>
                            <li className="achivement">
                              (2018-19)- Nikki got first position for English
                              recitation
                            </li>
                            <li className="achivement">
                              (2019-20) -Prachi got third position in Hindi
                              recitation
                            </li>
                            <li className="achivement">
                              Anushka got third position in English declamation
                            </li>
                            <li className="achivement">
                              Kanchan Got third position in English declamation
                            </li>
                          </ul>
                        </li>

                        <li>
                          <h4 className="text-white">Sports meet</h4>
                          <ul>
                            <li className="achivement">
                              (2018) Tushar class 5 100 m race and 200 m race got
                              third position
                            </li>
                            <li className="achivement">
                              Tushar class 5 high jump got third position
                            </li>
                            <li className="achivement">
                              Vinay class 5 in carrom got first position
                            </li>
                            <li className="achivement">
                              Kanchan class 400 m race third position
                            </li>
                            <li className="achivement">
                              Sakshi class 4 200 m race third position
                            </li>
                            <li className="achivement">
                              Anushka class 5 long jump got first position
                            </li>
                            <li className="achivement">
                              Anushka class 4 carrom got third position
                            </li>
                          </ul>
                        </li>


                        <h4 className="text-white">HGS sports meet</h4>
                        <ul>
                          <li className="achivement">Overall our school got first position trophy in inter HGS sports meet.</li>
                          <li className="achivement">
                            (2019) Rohit class 5, lakshika class 4, 100 and 200
                            metres race first position
                          </li>
                          <li className="achivement">
                            Vikas class 5,Lakshika class 4, long Jump second
                            position
                          </li>
                          <li className="achivement">
                            Anuj class 5, Ishika class 5, high jump first position
                          </li>
                          <li className="achivement">
                            Monica class 5, Nakul class 5, carrom first position
                          </li>
                        </ul>


                      </ul>

                    </div>
                    <div className="col-lg-6 achieveimage">
                      <img className="awardImage mt-5" src={award_1} />
                      <img className="awardImage mt-5" src={award_2} />
                      
                    </div>
                  </div>
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Achievements;
